export default function (_ref) {
  var store = _ref.store,
      redirect = _ref.redirect,
      req = _ref.req,
      route = _ref.route;

  if (process.server && !req) {
    return true;
  }

  if ((store.getters.isAuth === null || store.getters.isAuth === false) && !(req.session.authUser !== undefined && req.session.authUser.token !== undefined && req.session.authUser.token !== null)) {
    return redirect('/sign/in');
  }

  var path = route.path.split('/');
  var fact = false;

  if (path[1] !== '' && path[1] !== 'sign' && path[1] !== 'api' && path[1] !== '404' !== '_nuxt') {
    switch (path[1]) {
      case 'admin':
        if (store.getters.userGroups.indexOf(1) !== -1 || store.getters.userGroups.indexOf(2) !== -1) {
          fact = true;
        }
        break;
      case 'panel':
        fact = store.getters.userGroups.indexOf(3) !== -1;
        break;
      case 'support':
        fact = store.getters.userGroups.indexOf(7) !== -1;
        break;
    }
    if (!fact) {
      redirect('/');
    } else {
      return true;
    }
  } else {
    return true;
  }
}


//////////////////
// WEBPACK FOOTER
// ./middleware/check-rules.js
// module id = ./middleware/check-rules.js
// module chunks = 152